const ExportTypes = {
    ALL_METRICS: 'ALL_METRICS',
    SELECTED_METRICS: 'SELECTED_METRICS',
};

export default ExportTypes;
